export default defineNuxtPlugin(() => {
    addRouteMiddleware(
        'global-middleware',
        (to, from) => {
            let userAgent = '';
            
            if (process.server) {
                userAgent = useRequestHeaders()['user-agent'] || '';
            } else if (process.client) {
                userAgent = navigator.userAgent;
            }

            const isMobileOrTablet = /mobile|android|iphone|ipad|tablet/i.test(userAgent);

            // Screen width check
            const screenWidth = process.client ? window.innerWidth : 0;
            const isSmallScreen = screenWidth <= 768; // Threshold for small screens

            // Excluded paths
            const excludedPaths = ['/', '/field/users/preview', '/reads/preview', '/reads', '/field/review', '/field/users','/about', '/help', '/download', '/dashboard/preview', '/terms-and-conditions',
                ,'/shop', '/shop/product', '/checkout', '/order-confirmation'
            ];

            const valid = excludedPaths.filter(path => to.path.includes(path) && path !== '/').length > 0 || to.path === '/';
            // Redirect condition: If it's mobile or small screen, and not on an excluded path
            if (
                (isMobileOrTablet || (process.client && isSmallScreen)) &&
                !valid &&
                to.path !== '/mobile-warning'
            ) {
                return navigateTo('/mobile-warning'); // Redirect to the warning page
            }
        },
        { global: true }
    );
});
